/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery(document).ready(function($) {
  // var current_url = window.location.href;
  //   $('#top-brands-bar a') .each(function(){
  //    var url = $(this).attr('href');
  //    if(url == current_url){
  //    $('#top-brands-bar a').removeClass('active');
  //     $(this).addClass('active');
  //    } 
  // }); 
  $(document).on('click','.Drawer__Close',function(){
    
    $('#sidebar-menu').attr('aria-hidden','true');
  });
  $(document).on('click','#sidebar-cart .Drawer__Close',function(){
    
    $('#sidebar-cart').attr('aria-hidden','true');
  });
  if($('#top-brands-bar').hasClass('somelogo')){
    $('#top-brands-bar .brand-item.lusome').removeClass('active');
    $('#top-brands-bar .brand-item.some').addClass('active');
  }
  $('.owl-carousels').owlCarousel({
      loop:true,
      margin:10,
      nav:false,
      autoplay:true,
      autoplayTimeout:2000,
      autoplayHoverPause:true,
      dots:false,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
      }
  });
  $('.banner_top_icon_slider_inner').owlCarousel({
      center: true,
      items:4,
      loop:true,
      margin:30,
      nav:false,
      dots:false,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 6000,
      autoplaySpeed: 6000,
      autoplayHoverPause: false,
      responsive:{
          0:{
              items:1,
            margin:15,
          },
          600:{
              items:1
          },
          1000:{
              items:4
          }
      }
  });
  var vids = jQuery(".html_video_item video"); 
    jQuery.each(vids, function(){
           this.controls = false; 
    }); 
    //Loop though all Video tags and set Controls as false
    
    jQuery(".html_video_item video").click(function() {
      console.log(this); 
      if (this.paused) {
        this.play();
        jQuery(this).closest('.html_video_item').find('.play_icon').hide();
      } else {
        this.pause();
        jQuery(this).closest('.html_video_item').find('.play_icon').show();
      }
    });
  jQuery('.video_slider_inner_section').owlCarousel({
      	loop: true,
        responsiveClass: true,
        nav: true,
        margin: 0,    
        autoplayTimeout: 4000,
        smartSpeed: 400,
        center: true,
        navText: ['&#8592;', '&#8594;'],
        responsive: {
			0: {
            	items: 1,
                stagePadding: 50,
			},
			768: {
				items: 2,
                stagePadding: 50,
            },
			1170: {
				items: 3
			}
		}
  });
  jQuery('.our_customer_review_items').owlCarousel({
      	loop: true,
		center: false,
        rtl:false,
		autoplay: true,
        margin: 20,
        autoHeight : true,
        autoplayHoverPause:true,
        navText : ["←","→"],
		nav: true,
		dots:true,
        changeItemOnClick:false,
        autoplayTimeout: 3000,
        smartSpeed: 400,
        stagePadding: 100,
        responsive: {
			0: {
            	items: 1,
              stagePadding: 50,
			},
			768: {
				items: 2,
              stagePadding: 50,
			},
			1170: {
				items: 3
			}
		}
  });
  if(jQuery(".logo-slider-items").length){
      jQuery('.logo-slider-items').owlCarousel({
        	loop: true,
  		center: false,
          rtl:false,
    		autoplay: true,
          margin: 20,
          autoHeight : true,
          autoplayHoverPause:true,
          navText : ["←","→"],
  		nav: false,
  		dots:false,
          changeItemOnClick:false,
          autoplayTimeout: 3000,
          smartSpeed: 400,
          stagePadding: 100,
          responsive: {
  			0: {
              	items: 3,
                stagePadding: 50,
                autoHeight : false,
  			},
  			768: {
  				items: 4,
                stagePadding: 50,
                autoHeight : false,
  			},
  			1170: {
  				items: 6,
                  stagePadding: 50,
  			}
  		}
    });
  }
  if(jQuery(".investing_headline").length){
      jQuery('.investing_headline').owlCarousel({
        center: true,
        items:2,
        loop:true,
        margin:30,
        nav:false,
        dots:false,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 6000,
        autoplaySpeed: 6000,
        autoplayHoverPause: false,
        responsive:{
            0:{
                items:1,
              margin:15,
            },
            600:{
                items:1
            },
            1000:{
                items:2
            }
        }
  		
    });
  }
  if(jQuery(".comfort_guarantee_slider").length){
      var owl = jQuery('.comfort_guarantee_slider')
      if ( jQuery(window).width() < 980 ) {
          jQuery('.comfort_guarantee_slider').owlCarousel({
          responsive : {
            0 : {
              loop: true,
              responsiveClass: true,
              paddingType: "none", 
              dots: false,
              nav: false,
              autoHeight: true,
              items: 1,
              rtl:false,
              dotsEach:false,
              autoplay:true,
              autoplayHoverPause:true,
              navigation:false, 
              smartSpeed: 1000, 
              stagePadding: 100,
            },
            768 : {
              loop: true,
              responsiveClass: true,
              paddingType: "none", 
              dots: false,
              nav: false,
              autoHeight: true,
              items: 2,
              rtl:false,
              dotsEach:false,
              autoplay:true,
              autoplayHoverPause:true,
              navigation:false, 
              smartSpeed: 1000, 
              stagePadding: 100,
            }
          }
        });
      } else {
          owl.addClass('off');
      }
      jQuery(window).resize(function() {
          if ( jQuery(window).width() < 980 ) {
              if ( jQuery('.comfort_guarantee_slider').hasClass('off') ) {
                  jQuery('.comfort_guarantee_slider').owlCarousel({
                      responsive : {
                        0 : {
                          loop: true,
                          responsiveClass: true,
                          paddingType: "none", 
                          dots: false,
                          nav: false,
                          autoHeight: true,
                          items: 1,
                          navText : ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],  
                          rtl:false,
                          dotsEach:false,
                          autoplay:true,
                          autoplayHoverPause:true,
                          navigation:false, 
                          smartSpeed: 1000,  
                          stagePadding: 100,
                        },
                        768 : {
                          loop: true,
                          responsiveClass: true,
                          paddingType: "none", 
                          dots: false,
                          nav: false,
                          autoHeight: true,
                          items: 2,
                          rtl:false,
                          dotsEach:false,
                          autoplay:true,
                          autoplayHoverPause:true,
                          navigation:false, 
                          smartSpeed: 1000, 
                          stagePadding: 100,
                        }
                      }
                  });
                  owl.removeClass('off');
              }
          } else {
              if ( !jQuery('.comfort_guarantee_slider').hasClass('off') ) {
                  owl.addClass('off').trigger('destroy.owl.carousel');
                  owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
              }
          }
      });
      
  }
})